"use client";

import { HeroUIProvider as BaseHeroUIProvider } from "@heroui/react";

/**
 * HeroUI Provider
 */
export function HeroUIProvider({ children }: { children: React.ReactNode }) {
  return <BaseHeroUIProvider>{children}</BaseHeroUIProvider>;
}